import { create } from 'zustand';
import type { PerkId, LoadoutResponse } from '@cradle7/shared';

type LoadoutState = {
  unlockedPerks: PerkId[];
  loadoutPerkId: PerkId | null;
};

type LoadoutActions = {
  hydrateFromServer: (payload: LoadoutResponse) => void;
  setLoadoutLocal: (perkId: PerkId | null) => void;
  reset: () => void;
};

const INITIAL: LoadoutState = {
  unlockedPerks: [],
  loadoutPerkId: null,
};

export const useLoadoutStore = create<LoadoutState & LoadoutActions>((set) => ({
  ...INITIAL,
  hydrateFromServer: (p) => set({ unlockedPerks: p.unlockedPerks, loadoutPerkId: p.loadoutPerkId }),
  setLoadoutLocal: (perkId) => set({ loadoutPerkId: perkId }),
  reset: () => set({ ...INITIAL }),
}));
